export default __webpack_public_path__ + "static/media/HeroImageInvestPro.932e887f.png";